
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("c1txK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d35d6bdef48785fd$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $h89s9 = parcelRequire("h89s9");

var $fqDmW = parcelRequire("fqDmW");

var $6yJnE = parcelRequire("6yJnE");

var $gB4dU = parcelRequire("gB4dU");

var $tbh94 = parcelRequire("tbh94");
let $d35d6bdef48785fd$var$_ = (t)=>t, $d35d6bdef48785fd$var$t, $d35d6bdef48785fd$var$t1;
const $d35d6bdef48785fd$export$d25f95f50a0dfdf9 = (0, $fqDmW.default).div($d35d6bdef48785fd$var$t || ($d35d6bdef48785fd$var$t = $d35d6bdef48785fd$var$_`
  padding-right: 2px;
`));
const $d35d6bdef48785fd$var$StyledDiv = (0, $fqDmW.default).div($d35d6bdef48785fd$var$t1 || ($d35d6bdef48785fd$var$t1 = $d35d6bdef48785fd$var$_`
  input {
    ${0}
  }
`), (props)=>props.smallPlaceholder && "font-size: 14px !important;");
const $d35d6bdef48785fd$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $91i6m.useRef)(null);
    const [type, setType] = (0, $91i6m.useState)("password");
    (0, $91i6m.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        var _inputRef_current;
        setType(type === "password" ? "text" : "password");
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$var$StyledDiv, {
            smallPlaceholder: props.smallPlaceholder,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), (0, $b2I6k._)((0, $1Fos3._)({}, props), {
                type: type,
                autoComplete: type === "password" ? props.autoComplete || "off" : "off",
                spellCheck: false,
                ref: inputRef,
                elemAfterInput: /*#__PURE__*/ (0, $4ZSso.jsx)($d35d6bdef48785fd$export$d25f95f50a0dfdf9, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $tbh94.default), {
                        appearance: "subtle",
                        icon: type === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($gB4dU))) : (0, (/*@__PURE__*/$parcel$interopDefault($6yJnE))),
                        label: type === "text" ? "Hide password" : "Show password",
                        onClick: handleVisibilityToggle
                    })
                })
            }))
        })
    });
};
var $d35d6bdef48785fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($d35d6bdef48785fd$var$PasswordField);

});
parcelRegister("6yJnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c691eb080b990e3$var$_react = $4c691eb080b990e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4c691eb080b990e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4c691eb080b990e3$var$WatchIcon = (props)=>/*#__PURE__*/ $4c691eb080b990e3$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.977 13.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4"/></g></svg>`
    }, props));
$4c691eb080b990e3$var$WatchIcon.displayName = "WatchIcon";
var $4c691eb080b990e3$var$_default = $4c691eb080b990e3$var$WatchIcon;
module.exports.default = $4c691eb080b990e3$var$_default;

});

parcelRegister("gB4dU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c15360b5fe5850fb$var$_react = $c15360b5fe5850fb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $c15360b5fe5850fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c15360b5fe5850fb$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $c15360b5fe5850fb$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 01-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 014.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$c15360b5fe5850fb$var$WatchFilledIcon.displayName = "WatchFilledIcon";
var $c15360b5fe5850fb$var$_default = $c15360b5fe5850fb$var$WatchFilledIcon;
module.exports.default = $c15360b5fe5850fb$var$_default;

});

parcelRegister("tbh94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057b74a26f2e932f$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $jFzn9 = parcelRequire("jFzn9");

var $hbHfz = parcelRequire("hbHfz");
var $057b74a26f2e932f$var$_excluded = [
    "analyticsContext",
    "interactionName",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "icon",
    "label",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "shape",
    "type",
    "testId",
    "UNSAFE_size",
    "aria-label"
];
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $057b74a26f2e932f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, icon = _ref.icon, label = _ref.label, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, shape = _ref.shape, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, UNSAFE_size = _ref.UNSAFE_size, preventedAriaLabel = _ref["aria-label"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $057b74a26f2e932f$var$_excluded);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $hbHfz.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jFzn9.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$057b74a26f2e932f$var$IconButton.displayName = "IconButton";
var $057b74a26f2e932f$export$2e2bcd8739ae039 = $057b74a26f2e932f$var$IconButton;

});
parcelRegister("jFzn9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e51d48da70b110fd$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $iqLBO = parcelRequire("iqLBO");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $koa2c = parcelRequire("koa2c");

var $6A0cm = parcelRequire("6A0cm");

var $8YrnH = parcelRequire("8YrnH");

var $lqweQ = parcelRequire("lqweQ");

var $ky0rp = parcelRequire("ky0rp");
var $e51d48da70b110fd$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $e51d48da70b110fd$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $e51d48da70b110fd$var$focusRingStyles = (0, $lqweQ.xcss)({
    ":focus-visible": $e51d48da70b110fd$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $e51d48da70b110fd$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $e51d48da70b110fd$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $6A0cm.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $e51d48da70b110fd$var$_excluded);
    var interactionContext = (0, $91i6m.useContext)((0, $8YrnH.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "3.2.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $lqweQ.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $e51d48da70b110fd$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ky0rp.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $e51d48da70b110fd$export$2e2bcd8739ae039 = $e51d48da70b110fd$var$UNSAFE_PRESSABLE;

});
parcelRegister("lqweQ", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $f995088e095e75a8$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $f995088e095e75a8$export$f6c783d06584602c; });

var $iqLBO = parcelRequire("iqLBO");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $61RDg = parcelRequire("61RDg");

var $lPOF7 = parcelRequire("lPOF7");

var $8fKCR = parcelRequire("8fKCR");

var $e08gr = parcelRequire("e08gr");
function $f995088e095e75a8$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $f995088e095e75a8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $f995088e095e75a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f995088e095e75a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f995088e095e75a8$var$_arrayLikeToArray(o, minLen);
}
function $f995088e095e75a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f995088e095e75a8$export$9a199fbafee0014e = {
    backgroundColor: (0, $8fKCR.backgroundColorMap),
    blockSize: (0, $8fKCR.dimensionMap),
    borderBlockColor: (0, $8fKCR.borderColorMap),
    borderBlockEndColor: (0, $8fKCR.borderColorMap),
    borderBlockEndWidth: (0, $8fKCR.borderWidthMap),
    borderBlockStartColor: (0, $8fKCR.borderColorMap),
    borderBlockStartWidth: (0, $8fKCR.borderWidthMap),
    borderBlockWidth: (0, $8fKCR.borderWidthMap),
    borderBottomColor: (0, $8fKCR.borderColorMap),
    borderBottomLeftRadius: (0, $8fKCR.borderRadiusMap),
    borderBottomRightRadius: (0, $8fKCR.borderRadiusMap),
    borderBottomWidth: (0, $8fKCR.borderWidthMap),
    borderColor: (0, $8fKCR.borderColorMap),
    borderEndEndRadius: (0, $8fKCR.borderRadiusMap),
    borderEndStartRadius: (0, $8fKCR.borderRadiusMap),
    borderInlineColor: (0, $8fKCR.borderColorMap),
    borderInlineEndColor: (0, $8fKCR.borderColorMap),
    borderInlineEndWidth: (0, $8fKCR.borderWidthMap),
    borderInlineStartColor: (0, $8fKCR.borderColorMap),
    borderInlineStartWidth: (0, $8fKCR.borderWidthMap),
    borderInlineWidth: (0, $8fKCR.borderWidthMap),
    borderLeftColor: (0, $8fKCR.borderColorMap),
    borderLeftWidth: (0, $8fKCR.borderWidthMap),
    borderRadius: (0, $8fKCR.borderRadiusMap),
    borderRightColor: (0, $8fKCR.borderColorMap),
    borderRightWidth: (0, $8fKCR.borderWidthMap),
    borderStartEndRadius: (0, $8fKCR.borderRadiusMap),
    borderStartStartRadius: (0, $8fKCR.borderRadiusMap),
    borderTopColor: (0, $8fKCR.borderColorMap),
    borderTopLeftRadius: (0, $8fKCR.borderRadiusMap),
    borderTopRightRadius: (0, $8fKCR.borderRadiusMap),
    borderTopWidth: (0, $8fKCR.borderWidthMap),
    borderWidth: (0, $8fKCR.borderWidthMap),
    bottom: (0, $8fKCR.allSpaceMap),
    boxShadow: (0, $8fKCR.shadowMap),
    color: (0, $8fKCR.textColorMap),
    columnGap: (0, $8fKCR.positiveSpaceMap),
    gap: (0, $8fKCR.positiveSpaceMap),
    height: (0, $8fKCR.dimensionMap),
    inlineSize: (0, $8fKCR.dimensionMap),
    inset: (0, $8fKCR.allSpaceMap),
    insetBlock: (0, $8fKCR.allSpaceMap),
    insetBlockEnd: (0, $8fKCR.allSpaceMap),
    insetBlockStart: (0, $8fKCR.allSpaceMap),
    insetInline: (0, $8fKCR.allSpaceMap),
    insetInlineEnd: (0, $8fKCR.allSpaceMap),
    insetInlineStart: (0, $8fKCR.allSpaceMap),
    left: (0, $8fKCR.allSpaceMap),
    margin: (0, $8fKCR.allSpaceMap),
    marginBlock: (0, $8fKCR.allSpaceMap),
    marginBlockEnd: (0, $8fKCR.allSpaceMap),
    marginBlockStart: (0, $8fKCR.allSpaceMap),
    marginBottom: (0, $8fKCR.allSpaceMap),
    marginInline: (0, $8fKCR.allSpaceMap),
    marginInlineEnd: (0, $8fKCR.allSpaceMap),
    marginInlineStart: (0, $8fKCR.allSpaceMap),
    marginLeft: (0, $8fKCR.allSpaceMap),
    marginRight: (0, $8fKCR.allSpaceMap),
    marginTop: (0, $8fKCR.allSpaceMap),
    maxBlockSize: (0, $8fKCR.dimensionMap),
    maxHeight: (0, $8fKCR.dimensionMap),
    maxInlineSize: (0, $8fKCR.dimensionMap),
    maxWidth: (0, $8fKCR.dimensionMap),
    minBlockSize: (0, $8fKCR.dimensionMap),
    minHeight: (0, $8fKCR.dimensionMap),
    minInlineSize: (0, $8fKCR.dimensionMap),
    minWidth: (0, $8fKCR.dimensionMap),
    opacity: (0, $8fKCR.opacityMap),
    outlineColor: (0, $8fKCR.borderColorMap),
    outlineOffset: (0, $8fKCR.positiveSpaceMap),
    outlineWidth: (0, $8fKCR.borderWidthMap),
    padding: (0, $8fKCR.positiveSpaceMap),
    paddingBlock: (0, $8fKCR.positiveSpaceMap),
    paddingBlockEnd: (0, $8fKCR.positiveSpaceMap),
    paddingBlockStart: (0, $8fKCR.positiveSpaceMap),
    paddingBottom: (0, $8fKCR.positiveSpaceMap),
    paddingInline: (0, $8fKCR.positiveSpaceMap),
    paddingInlineEnd: (0, $8fKCR.positiveSpaceMap),
    paddingInlineStart: (0, $8fKCR.positiveSpaceMap),
    paddingLeft: (0, $8fKCR.positiveSpaceMap),
    paddingRight: (0, $8fKCR.positiveSpaceMap),
    paddingTop: (0, $8fKCR.positiveSpaceMap),
    right: (0, $8fKCR.allSpaceMap),
    rowGap: (0, $8fKCR.positiveSpaceMap),
    top: (0, $8fKCR.allSpaceMap),
    width: (0, $8fKCR.dimensionMap),
    zIndex: (0, $8fKCR.layerMap)
};
var $f995088e095e75a8$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $f995088e095e75a8$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $e08gr === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr.env) === "object" && false;
};
var $f995088e095e75a8$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $f995088e095e75a8$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $f995088e095e75a8$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value) === "object" && $f995088e095e75a8$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($f995088e095e75a8$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($f995088e095e75a8$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $f995088e095e75a8$export$9a199fbafee0014e)) return;
        var tokenValue = $f995088e095e75a8$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $f995088e095e75a8$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $f995088e095e75a8$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $f995088e095e75a8$var$uniqueSymbol, (0, $lPOF7.css)(transformedStyles));
};
var $f995088e095e75a8$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $f995088e095e75a8$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$f995088e095e75a8$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $f995088e095e75a8$export$f6c783d06584602c(style) {
    return $f995088e095e75a8$var$baseXcss(style);
}

});
parcelRegister("8fKCR", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $6023e45ca4d291ab$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $6023e45ca4d291ab$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $6023e45ca4d291ab$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $6023e45ca4d291ab$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $6023e45ca4d291ab$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $6023e45ca4d291ab$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $6023e45ca4d291ab$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $6023e45ca4d291ab$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $6023e45ca4d291ab$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $6023e45ca4d291ab$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $6023e45ca4d291ab$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $6023e45ca4d291ab$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $6023e45ca4d291ab$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $6023e45ca4d291ab$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $6023e45ca4d291ab$export$5e65a44e5b6ecadb; });

var $dsN6L = parcelRequire("dsN6L");

var $lPOF7 = parcelRequire("lPOF7");

var $2S8bR = parcelRequire("2S8bR");
function $6023e45ca4d291ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6023e45ca4d291ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6023e45ca4d291ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6023e45ca4d291ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6023e45ca4d291ab$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6023e45ca4d291ab$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6023e45ca4d291ab$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6023e45ca4d291ab$export$632685d741f3dbbf = $6023e45ca4d291ab$var$_objectSpread($6023e45ca4d291ab$var$_objectSpread({}, $6023e45ca4d291ab$export$958d0ae7f2977ae4), $6023e45ca4d291ab$export$d2dc61f58390201c);
var $6023e45ca4d291ab$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6023e45ca4d291ab$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6023e45ca4d291ab$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $6023e45ca4d291ab$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $6023e45ca4d291ab$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $6023e45ca4d291ab$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6023e45ca4d291ab$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $6023e45ca4d291ab$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $6023e45ca4d291ab$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6023e45ca4d291ab$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $6023e45ca4d291ab$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $6023e45ca4d291ab$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $6023e45ca4d291ab$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $6023e45ca4d291ab$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $6023e45ca4d291ab$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $6023e45ca4d291ab$export$b5bac06d7d8fd0d1 = {
    body: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $6023e45ca4d291ab$export$b27166c9cf2c9f74 = {
    ui: 'var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "ui.small": 'var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $6023e45ca4d291ab$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6023e45ca4d291ab$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $lPOF7.css)((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6023e45ca4d291ab$export$e615f061ca585a6c = $6023e45ca4d291ab$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6023e45ca4d291ab$var$getSerializedStylesMap(spacingProperty, $6023e45ca4d291ab$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6023e45ca4d291ab$export$bf46c3f9eeafc71f = $6023e45ca4d291ab$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6023e45ca4d291ab$var$getSerializedStylesMap(spacingProperty, $6023e45ca4d291ab$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6023e45ca4d291ab$export$e7af83bafe7f9e63 = $6023e45ca4d291ab$var$getSerializedStylesMap("backgroundColor", $6023e45ca4d291ab$export$d1d79bf68ac056bd);
var $6023e45ca4d291ab$export$3a1bcba60b23d7f0 = $6023e45ca4d291ab$var$getSerializedStylesMap("color", $6023e45ca4d291ab$export$8473307aa00d6ea1);
var $6023e45ca4d291ab$export$f7183c9e2dbc2543 = $6023e45ca4d291ab$var$getSerializedStylesMap("fontSize", $6023e45ca4d291ab$export$6cc560b4dedf3816);
var $6023e45ca4d291ab$export$45f3f4fe16f9f7d5 = $6023e45ca4d291ab$var$getSerializedStylesMap("fontWeight", $6023e45ca4d291ab$export$303e322c6b1ed114);
var $6023e45ca4d291ab$export$68cc305da27dbaa4 = $6023e45ca4d291ab$var$getSerializedStylesMap("fontFamily", $6023e45ca4d291ab$export$3c7e9587132614b4);
var $6023e45ca4d291ab$export$8be4a21014f48eb1 = $6023e45ca4d291ab$var$getSerializedStylesMap("lineHeight", $6023e45ca4d291ab$export$360c29a380c1a34);
var $6023e45ca4d291ab$export$a1962444bbf058e = $6023e45ca4d291ab$var$getSerializedStylesMap("font", $6023e45ca4d291ab$export$b5bac06d7d8fd0d1);
var $6023e45ca4d291ab$export$ca3e246f24657bd6 = $6023e45ca4d291ab$var$getSerializedStylesMap("font", $6023e45ca4d291ab$export$b27166c9cf2c9f74);
var $6023e45ca4d291ab$export$ff257d957d48c421 = $6023e45ca4d291ab$var$getSerializedStylesMap((0, $2S8bR.CURRENT_SURFACE_CSS_VAR), $6023e45ca4d291ab$export$41a358c9c2356760);
var $6023e45ca4d291ab$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6023e45ca4d291ab$export$41a358c9c2356760[color] !== undefined;
};

});


parcelRegister("ky0rp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef5753369a71ed8b$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $8fKCR = parcelRequire("8fKCR");

var $lqweQ = parcelRequire("lqweQ");

var $3LS6A = parcelRequire("3LS6A");
var $ef5753369a71ed8b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $ef5753369a71ed8b$var$_excluded2 = [
    "className"
];
var $ef5753369a71ed8b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $ef5753369a71ed8b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $ef5753369a71ed8b$var$_excluded2);
    var resolvedStyles = (0, $lqweQ.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $lPOF7.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $ef5753369a71ed8b$var$baseStyles,
            backgroundColor && (0, $8fKCR.backgroundColorStylesMap)[backgroundColor],
            (0, $8fKCR.isSurfaceColorToken)(backgroundColor) && (0, $8fKCR.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $8fKCR.paddingStylesMap).padding[padding],
            paddingBlock && (0, $8fKCR.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $8fKCR.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $8fKCR.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $8fKCR.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $8fKCR.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $8fKCR.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $lPOF7.jsx)((0, $3LS6A.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $ef5753369a71ed8b$export$2e2bcd8739ae039 = $ef5753369a71ed8b$export$e71c4d32a2263218;
var $ef5753369a71ed8b$var$baseStyles = (0, $lPOF7.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("3LS6A", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $2befbb139a8fce57$export$1ca2a26fecb070ae; });

var $91i6m = parcelRequire("91i6m");
var $2befbb139a8fce57$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $91i6m.createContext)("elevation.surface");
var $2befbb139a8fce57$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $91i6m.useContext)($2befbb139a8fce57$export$1ca2a26fecb070ae);
};
$2befbb139a8fce57$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("hbHfz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8350358a3b7f001$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kQU6o = parcelRequire("kQU6o");

var $fXpPO = parcelRequire("fXpPO");

var $6U7Fi = parcelRequire("6U7Fi");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $c8350358a3b7f001$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay);
    var isCircle = shape === "circle";
    var baseProps = (0, $6U7Fi.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
            label: "",
            size: UNSAFE_size
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $c8350358a3b7f001$export$2e2bcd8739ae039 = $c8350358a3b7f001$var$useIconButton;

});
parcelRegister("fXpPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e067efc04f5090$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $ky0rp = parcelRequire("ky0rp");
var $lqweQ = parcelRequire("lqweQ");
var $b9e067efc04f5090$var$textStyles = (0, $lqweQ.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $b9e067efc04f5090$var$iconStyles = (0, $lqweQ.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $b9e067efc04f5090$var$commonStyles = (0, $lqweQ.xcss)({
    transition: "opacity 0.3s"
});
var $b9e067efc04f5090$var$fadeStyles = (0, $lqweQ.xcss)({
    opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b9e067efc04f5090$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ky0rp.default), {
        as: "span",
        xcss: [
            $b9e067efc04f5090$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(type === "text" ? [
            $b9e067efc04f5090$var$textStyles
        ] : [
            $b9e067efc04f5090$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(hasOverlay ? [
            $b9e067efc04f5090$var$fadeStyles
        ] : []))
    }, children);
};
var $b9e067efc04f5090$export$2e2bcd8739ae039 = $b9e067efc04f5090$var$Content;

});

parcelRegister("6U7Fi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $506deb25fd0d8934$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $a4cH2 = parcelRequire("a4cH2");

var $ky0rp = parcelRequire("ky0rp");
var $lqweQ = parcelRequire("lqweQ");

var $ImPgp = parcelRequire("ImPgp");

var $7ZUmN = parcelRequire("7ZUmN");

var $azhMS = parcelRequire("azhMS");
function $506deb25fd0d8934$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $506deb25fd0d8934$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $506deb25fd0d8934$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $506deb25fd0d8934$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $506deb25fd0d8934$var$overlayStyles = (0, $lqweQ.xcss)({
    position: "absolute",
    insetInlineStart: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetBlockEnd: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $506deb25fd0d8934$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing;
    var ourRef = (0, $91i6m.useRef)();
    var splitButtonContext = (0, $ImPgp.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isHighlighted = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isHighlighted) || false;
    var isActiveOverSelected = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isActiveOverSelected) || false;
    var setRef = (0, $91i6m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref === null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    (0, $a4cH2.default)(ourRef, autoFocus);
    var buttonXCSS = (0, $91i6m.useMemo)(function() {
        return (0, $azhMS.getXCSS)({
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isHighlighted: isHighlighted,
            isActiveOverSelected: isActiveOverSelected,
            shouldFitContainer: shouldFitContainer,
            isIconButton: isIconButton,
            isCircle: isCircle,
            hasOverlay: Boolean(overlay),
            isLink: buttonType === "link",
            hasIconBefore: hasIconBefore,
            hasIconAfter: hasIconAfter,
            isSplit: isSplitButton,
            isNavigationSplit: isNavigationSplitButton
        });
    }, [
        appearance,
        buttonType,
        spacing,
        isDisabled,
        isSelected,
        isHighlighted,
        isActiveOverSelected,
        isIconButton,
        isCircle,
        shouldFitContainer,
        overlay,
        hasIconBefore,
        hasIconAfter,
        isSplitButton,
        isNavigationSplitButton
    ]);
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    return $506deb25fd0d8934$var$_objectSpread({
        ref: setRef,
        xcss: buttonXCSS,
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ky0rp.default), {
            as: "span",
            xcss: $506deb25fd0d8934$var$overlayStyles
        }, overlay) : null)
    }, (0, $7ZUmN.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $506deb25fd0d8934$export$2e2bcd8739ae039 = $506deb25fd0d8934$var$useButtonBase;

});
parcelRegister("ImPgp", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $0855d0e91824b675$export$47e2c6fdb142d947; });

var $91i6m = parcelRequire("91i6m");
var $0855d0e91824b675$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $0855d0e91824b675$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $91i6m.useContext)($0855d0e91824b675$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("7ZUmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d29f42e5bfd9987$export$2e2bcd8739ae039; });
function $5d29f42e5bfd9987$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5d29f42e5bfd9987$var$tabKeyCode = 9;
function $5d29f42e5bfd9987$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5d29f42e5bfd9987$var$tabKeyCode) return;
    $5d29f42e5bfd9987$var$abort(event);
}
function $5d29f42e5bfd9987$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5d29f42e5bfd9987$var$abort,
        onMouseUpCapture: $5d29f42e5bfd9987$var$abort,
        onKeyDownCapture: $5d29f42e5bfd9987$var$onKey,
        onKeyUpCapture: $5d29f42e5bfd9987$var$onKey,
        onTouchStartCapture: $5d29f42e5bfd9987$var$abort,
        onTouchEndCapture: $5d29f42e5bfd9987$var$abort,
        onPointerDownCapture: $5d29f42e5bfd9987$var$abort,
        onPointerUpCapture: $5d29f42e5bfd9987$var$abort,
        onClickCapture: $5d29f42e5bfd9987$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5d29f42e5bfd9987$var$abort
    } : events;
}

});

parcelRegister("azhMS", function(module, exports) {

$parcel$export(module.exports, "getXCSS", function () { return $7b1af87bf8ecf509$export$f9dc8dc4cff30fc6; });

var $dsN6L = parcelRequire("dsN6L");

var $lqweQ = parcelRequire("lqweQ");

var $6e88g = parcelRequire("6e88g");

var $9PJhp = parcelRequire("9PJhp");
function $7b1af87bf8ecf509$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b1af87bf8ecf509$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b1af87bf8ecf509$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b1af87bf8ecf509$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b1af87bf8ecf509$var$fontSize = (0, $6e88g.fontSize)();
var $7b1af87bf8ecf509$export$6c2552e9776539bb = {
    default: "".concat(32 / $7b1af87bf8ecf509$var$fontSize, "em"),
    compact: "".concat(24 / $7b1af87bf8ecf509$var$fontSize, "em"),
    none: "auto"
};
var $7b1af87bf8ecf509$var$lineHeights = {
    default: $7b1af87bf8ecf509$export$6c2552e9776539bb.default,
    compact: $7b1af87bf8ecf509$export$6c2552e9776539bb.compact,
    none: "inherit"
};
var $7b1af87bf8ecf509$var$paddingInline = {
    default: {
        default: "space.150",
        withIcon: "space.100"
    },
    compact: {
        default: "space.150",
        withIcon: "space.100"
    },
    none: {
        default: "space.0",
        withIcon: "space.0"
    }
};
var $7b1af87bf8ecf509$var$gap = {
    compact: "space.050",
    default: "space.050",
    none: "space.0"
};
var $7b1af87bf8ecf509$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $7b1af87bf8ecf509$var$splitBorderStyles = {
    ":focus-visible": {
        zIndex: 1
    }
};
function $7b1af87bf8ecf509$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key;
    return group[key] || group.default;
}
function $7b1af87bf8ecf509$var$getColors(_ref2) {
    var appearance = _ref2.appearance, _ref2$interactionStat = _ref2.interactionState, interactionState = _ref2$interactionStat === void 0 ? "default" : _ref2$interactionStat, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, isHighlighted = _ref2.isHighlighted, isActiveOverSelected = _ref2.isActiveOverSelected, hasOverlay = _ref2.hasOverlay;
    var key = interactionState;
    // Overlay does not change color on interaction, revert to 'default' or resting state
    key = hasOverlay ? "default" : key;
    key = isSelected || isHighlighted ? isActiveOverSelected ? "active" : "selected" : key;
    // Disabled colors overrule everything else
    key = isDisabled ? "disabled" : key;
    return {
        backgroundColor: $7b1af87bf8ecf509$var$getColor({
            group: (0, $9PJhp.default).background[appearance],
            key: key
        }),
        color: "".concat($7b1af87bf8ecf509$var$getColor({
            group: (0, $9PJhp.default).color[appearance],
            key: key
        }))
    };
}
function $7b1af87bf8ecf509$export$f9dc8dc4cff30fc6(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, isHighlighted = _ref3.isHighlighted, isActiveOverSelected = _ref3.isActiveOverSelected, isIconButton = _ref3.isIconButton, isCircle = _ref3.isCircle, shouldFitContainer = _ref3.shouldFitContainer, isLink = _ref3.isLink, isSplit = _ref3.isSplit, isNavigationSplit = _ref3.isNavigationSplit, hasOverlay = _ref3.hasOverlay, hasIconBefore = _ref3.hasIconBefore, hasIconAfter = _ref3.hasIconAfter;
    var baseColors = $7b1af87bf8ecf509$var$getColors({
        appearance: appearance,
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        isActiveOverSelected: isActiveOverSelected,
        isDisabled: isDisabled
    });
    var combinedBaseColorStyles = isLink ? $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, baseColors), {}, {
        textDecoration: "none",
        // Disabling visited styles (by re-declaring the base colors)
        ":visited": baseColors
    }) : isNavigationSplit && !isSelected ? $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, baseColors), {}, {
        backgroundColor: "color.background.neutral.subtle"
    }) : baseColors;
    var height = $7b1af87bf8ecf509$export$6c2552e9776539bb[spacing];
    var width = shouldFitContainer ? "100%" : "auto";
    width = isIconButton ? isNavigationSplit ? "24px" : height : width;
    var defaultPaddingInlineStart = $7b1af87bf8ecf509$var$paddingInline[spacing][hasIconBefore ? "withIcon" : "default"];
    var defaultPaddingInlineEnd = $7b1af87bf8ecf509$var$paddingInline[spacing][hasIconAfter ? "withIcon" : "default"];
    var splitButtonStyles = isSplit ? $7b1af87bf8ecf509$var$splitBorderStyles : {};
    var getNavigationSplitButtonPaddings = function getNavigationSplitButtonPaddings() {
        if (isNavigationSplit) return {
            paddingInlineStart: "space.075",
            paddingInlineEnd: "space.075"
        };
        return {
            paddingInlineStart: isIconButton ? "space.0" : defaultPaddingInlineStart,
            paddingInlineEnd: isIconButton ? "space.0" : defaultPaddingInlineEnd
        };
    };
    var _getNavigationSplitBu = getNavigationSplitButtonPaddings(), paddingInlineStart = _getNavigationSplitBu.paddingInlineStart, paddingInlineEnd = _getNavigationSplitBu.paddingInlineEnd;
    return (0, $lqweQ.xcss)($7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({
        alignItems: "baseline",
        borderWidth: "border.width.0",
        borderRadius: isCircle && !isSplit ? "border.radius.circle" : "border.radius.100",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        fontFamily: "inherit",
        fontWeight: 500,
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap",
        height: height,
        lineHeight: $7b1af87bf8ecf509$var$lineHeights[spacing],
        paddingBlock: "space.0",
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        columnGap: $7b1af87bf8ecf509$var$gap[spacing],
        verticalAlign: $7b1af87bf8ecf509$var$verticalAlign[spacing],
        width: width,
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, combinedBaseColorStyles), isDisabled || hasOverlay ? {
        cursor: "not-allowed"
    } : {}), {}, {
        ":hover": $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, $7b1af87bf8ecf509$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "hover",
            hasOverlay: hasOverlay
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "none",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        ":active": $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, $7b1af87bf8ecf509$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "active",
            hasOverlay: hasOverlay
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        })
    }, splitButtonStyles));
}

});
parcelRegister("9PJhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $728c0014d32d53d9$export$2e2bcd8739ae039; });

var $kLNLK = parcelRequire("kLNLK");
var $728c0014d32d53d9$var$values = {
    // Default appearance
    background: {
        default: {
            /**
       * Some colors need specific fallback colors specified
       * to match the original Button when no theme is active.
       *
       * This is because the `xcss` automatic token fallbacks use
       * the legacy themes, which do not match original colors.
       */ // @ts-expect-error
            default: "var(--ds-background-neutral, ".concat($kLNLK.N20A, ")"),
            hover: "color.background.neutral.hovered",
            active: "color.background.neutral.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        primary: {
            default: "color.background.brand.bold",
            hover: "color.background.brand.bold.hovered",
            active: "color.background.brand.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        warning: {
            default: "color.background.warning.bold",
            hover: "color.background.warning.bold.hovered",
            active: "color.background.warning.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.Y400, ")")
        },
        danger: {
            default: "color.background.danger.bold",
            hover: "color.background.danger.bold.hovered",
            active: "color.background.danger.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.R500, ")")
        },
        link: {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        subtle: {
            default: "color.background.neutral.subtle",
            hover: "color.background.neutral.subtle.hovered",
            active: "color.background.neutral.subtle.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-neutral-subtle, none)",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        "subtle-link": {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        }
    },
    color: {
        default: {
            // @ts-expect-error
            default: "var(--ds-text, ".concat($kLNLK.N500, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.B400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        primary: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        warning: {
            default: "color.text.warning.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N800, ")")
        },
        danger: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N0, ")")
        },
        link: {
            default: "color.link",
            // @ts-expect-error
            hover: "var(--ds-link, ".concat($kLNLK.B300, ")"),
            active: "color.link.pressed",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        subtle: {
            // @ts-expect-error
            default: "var(--ds-text, ".concat($kLNLK.N500, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.B400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        "subtle-link": {
            // @ts-expect-error
            default: "var(--ds-text-subtle, ".concat($kLNLK.N200, ")"),
            // @ts-expect-error
            hover: "var(--ds-text-subtle, ".concat($kLNLK.N90, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.N400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        }
    }
};
var $728c0014d32d53d9$export$2e2bcd8739ae039 = $728c0014d32d53d9$var$values;

});







//# sourceMappingURL=ChangePasswordPage.05f1b480.js.map
